import styled from 'styled-components';
import { Card } from 'ui-toolkit';

export const StyledItemMetaDataModal = styled.div<{}>`
  position: relative;
  width: 100%;
`;
export const StyledItemMetaDataModalCell = styled.div<{}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledItemMetaDataModalCardLabel = styled.strong<{}>`
  width: 100%;
`;

export const StyledItemMetaDataModalCard = styled(Card)<{}>`
  padding: ${(props) => props.theme.spacing.spacing4};
  min-width: 400px;
  position: absolute;
  top: 0;
  right: ${(props) => -props.theme.spacing.defaultPaddingValue + props.theme.spacing.baseUnit};
  left: ${(props) => -props.theme.spacing.defaultPaddingValue + props.theme.spacing.baseUnit};
`;
